import * as wjcCore from '@mescius/wijmo';
import * as wjGridFilter from '@mescius/wijmo.grid.filter';
import * as wjMultirow from '@mescius/wijmo.grid.multirow';
import * as wjNav from '@mescius/wijmo.nav';

'use strict';

import {ViewChild, Component, AfterViewInit} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {HttpClient} from '@angular/common/http';
import {Store} from '@ngrx/store';
import {ToasterService} from 'angular2-toaster';
import {TranslocoService} from '@jsverse/transloco';
import {ActivePromotionConfig} from '../config/active-promotion.config';
import {GalleryComponent, GalleryItem, ImageItem} from '../ui/gallery/index';
import {asOrientDate, isOrientDate, DataService, OrientDBCollectionView} from '@cosbeni/database';
import {LoadUserAction} from '../ngrx/actions/user.action';
import {switchMap} from 'rxjs/operators';

@Component({
    standalone: false,
    selector: 'cj-user-item',
    templateUrl: 'item.component.html',
    styleUrls: ['item.component.css']
})

export class ItemComponent implements AfterViewInit {
    readonly: Boolean = true;
    @ViewChild('itemGrid') itemGrid: wjMultirow.MultiRow;
    @ViewChild('imageGallery') imageGallery: GalleryComponent;
    @ViewChild('itemTabPanel') itemTabPanel: wjNav.TabPanel;
    filter: wjGridFilter.FlexGridFilter;
    predicate: any = {
        id: null,
        place: '',
        lane: '',
        category: '',
        auctionResult: '',
        buyer: null,
        seller: null,
        name: '',
        description: '',
        eventDate: null,
    };
    screenWidth: number;
    user: any;
    now: Date = new Date();
    price: number = 0;
    item: any = {};
    items: OrientDBCollectionView;
    histories: wjcCore.CollectionView = new wjcCore.CollectionView([]);
    view: string = 'easy';
    mode: string = 'view';
    tableType: string = 'image';
    galleryItems: GalleryItem[];
    optionAuction: any[] = [];
    optionAuctionResult: any[] = [];
    optionCategory: any[] = [];
    optionLane: any[] = [];
    optionPlace: any[] = [];
    optionUnit: any[] = [];

    constructor(public store: Store<any>, public dataService: DataService, public toasterService: ToasterService, private transloco: TranslocoService, private route: ActivatedRoute, private http: HttpClient) {
        this.store.dispatch(new LoadUserAction());
        this.store.select<any>('activePromotionFeature').subscribe((digitalAuction: any) => {
            if (wjcCore.isObject(digitalAuction.user) && digitalAuction.user.loaded) {
                this.user = digitalAuction.user.user;
            }
        });
        const uuid = this.route.snapshot.paramMap.get('id')!;
        this.dataService.query({
            sql: 'SELECT FROM DA_Item WHERE uuid = \'' + uuid + '\'',
            count: 'SELECT FROM DA_Item WHERE uuid = \'' + uuid + '\'',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.item = Object.assign({}, data.results[0]);
                if (wjcCore.isObject(this.item.auction)) {
                    for (let auction of this.optionAuction) {
                        if (auction['@rid'] == this.item.auction['@rid']) {
                            this.item.auction = auction;
                        }
                    }
                }
                if (wjcCore.isObject(this.imageGallery)) {
                    this.imageGallery.reset();
                }
                if (this.item.hasOwnProperty('images') && wjcCore.isArray(this.item.images)) {
                    this.galleryItems = [];
                    for (let name of this.item.images) {
                        this.galleryItems.push(new ImageItem({
                            src: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name,
                            thumb: ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name
                        }));
                    }
                }
                this.price = this.item.minimumPrice;
                this.loadHistories();
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            count: 'SELECT FROM DA_Auction ORDER BY eventDate DESC',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                for (let auction of data.results) {
                    if (isOrientDate(auction.eventDate)) {
                        auction.eventDate = asOrientDate(auction.eventDate);
                        auction.display = wjcCore.Globalize.formatDate(auction.eventDate, 'yyyy/MM/dd HH:mm:ss') + ' ' + auction.place + ' ' + auction.lane;
                    }
                }
                this.optionAuction = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'セリ結果\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionAuctionResult = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'商品種別\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionCategory = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'レーン\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionLane = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'会場名\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionPlace = data.results;
            }
        });
        this.dataService.query({
            sql: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            count: 'SELECT FROM DA_Master WHERE category =\'単位\' order by sort',
            fetchPlan: '*:1',
        }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
            if (wjcCore.isArray(data.results)) {
                this.optionUnit = data.results;
            }
        });
        this.resizeScreen();
    }

    resizeScreen(event?) {
        this.screenWidth = window.innerWidth;
    }

    ngAfterViewInit() {
    }

    loadHistories() {
        this.histories.sourceCollection = [];
        this.histories.refresh();
        if (this.item != null && wjcCore.isObject(this.user)) {
            this.dataService.query({
                sql: 'SELECT FROM DA_History WHERE item = ' + this.item['@rid'] + ' AND buyer = ' + this.user['@rid'] + ' order by historyDate desc',
                count: 'SELECT FROM DA_History WHERE item = ' + this.item['@rid'] + ' AND buyer = ' + this.user['@rid'] + ' order by historyDate desc',
                fetchPlan: '*:1',
            }, ActivePromotionConfig.SERVER_URL).subscribe(data => {
                if (wjcCore.isArray(data.results)) {
                    for (let history of data.results) {
                        if (isOrientDate(history.historyDate)) {
                            history.historyDate = asOrientDate(history.historyDate);
                        }
                    }
                    this.histories.sourceCollection = data.results;
                    this.histories.refresh();
                }
            });
        }
    }

    search(name = ''): void {
        let where = ['published >= date(\'2000-01-01\',\'yyyy-MM-dd\')'];
        if (!wjcCore.isNullOrWhiteSpace(name)) {
            if (name == '自社落札済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('buyer = ' + this.user['@rid']);
            }
            if (name == '自社落札中') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
                where.push('@rid IN (SELECT item FROM (SELECT count(*), item FROM DA_History WHERE buyer = ' + this.user['@rid'] + ' GROUP BY item))');
            }
            if (name == '落札可能') {
                where.push('auction.eventDate > date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (name == '終了済') {
                where.push('auction.eventDate <= date(\'' + wjcCore.Globalize.formatDate(new Date(), 'yyyy-MM-dd HH:mm:ss') + '\',\'yyyy-MM-dd HH:mm:ss\')');
            }
            if (name == 'お気に入り') {
                where.push('followers IN [' + this.user['@rid'] + ']');
            }
        } else {
            if (wjcCore.isNumber(this.predicate.id)) {
                where.push('id = ' + this.predicate.id);
            }
            if (wjcCore.isDate(this.predicate.eventDate)) {
                where.push('auction.eventDate >= date(\'' + wjcCore.Globalize.formatDate(this.predicate.eventDate, 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
                where.push('auction.eventDate < date(\'' + wjcCore.Globalize.formatDate(wjcCore.DateTime.addDays(this.predicate.eventDate, 1), 'yyyy-MM-dd') + '\',\'yyyy-MM-dd\')');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.place)) {
                where.push('auction.place = \'' + this.predicate.place + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.lane)) {
                where.push('auction.lane = \'' + this.predicate.lane + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.category)) {
                where.push('category = \'' + this.predicate.category + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.auctionResult)) {
                where.push('auctionResult = \'' + this.predicate.auctionResult + '\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.name)) {
                where.push('name LIKE \'%' + this.predicate.name + '%\'');
            }
            if (!wjcCore.isNullOrWhiteSpace(this.predicate.description)) {
                where.push('description LIKE \'%' + this.predicate.description + '%\'');
            }
        }
        this.items.filterOnServer = false;
        this.items.filterSpecial = where.join(' AND ');
        this.items.filterOnServer = true;
    }

    resetPredicate() {
        this.predicate = {
            id: null,
            place: '',
            lane: '',
            category: '',
            auctionResult: '',
            buyer: null,
            seller: null,
            name: '',
            description: '',
            eventDate: null,
        };
    }

    getImageSrc(item, name): string {
        return ActivePromotionConfig.IMAGE_URL + item.id + '/' + name;
    }

    getCurrentImageSrc(name): string {
        return ActivePromotionConfig.IMAGE_URL + this.item.id + '/' + name;
    }

    addFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item ADD followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.added_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers)) {
                    item.followers.push(this.user['@rid']);
                } else {
                    item.followers = [this.user['@rid']];
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    removeFollowers(item) {
        let sql = 'BEGIN\n';
        sql = sql + 'UPDATE DA_Item REMOVE followers = ' + this.user['@rid'] + ' WHERE @rid = ' + item['@rid'] + '\n';
        sql = sql + 'COMMIT RETRY 100\n';
        this.dataService.batch({sql: sql}, ActivePromotionConfig.SERVER_URL).subscribe((response: any) => {
                this.toasterService.pop('info', this.transloco.translate('user.favorites'), this.transloco.translate('user.removed_message'));
                if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
                    let index = item.followers.indexOf(this.user['@rid']);
                    item.followers.splice(index, 1);
                }
            },
            (error: any) => {
                this.toasterService.pop('error', this.transloco.translate('user.favorites'), this.transloco.translate('user.failed_message'));
            }
        );
    }

    isFollowers(item) {
        let result = false;
        if (item.hasOwnProperty('followers') && wjcCore.isArray(item.followers) && item.followers.indexOf(this.user['@rid']) >= 0) {
            return true;
        }
        return result;
    }

}

